import React from 'react';
import styled from '@emotion/styled';

// import SelectAge from './SelectAge';
// import SelectDate from './SelectDate';
import SelectTheme from './SelectTheme';

const SelectTargetdiv = styled.div`
width:80%;
max-width:100%;
display:block;
@media (max-width:${props => props.theme.breakpoints.md}) {
width:100%;
}
@media (min-width:${props => props.theme.breakpoints.sm}) { 
display:inline-block;
}
`;

const SelectTarget = () => (
<SelectTargetdiv>
    <SelectTheme />
</SelectTargetdiv>
    )

export default SelectTarget;